import React, { useState, useEffect } from "react";
import "./ApproveReviews.css";

function ApproveReviews() {
  const [reviews, setReviews] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    // Simulate API data — some pending reviews
    const mockData = generateMockReviews(0); // 0 shows empty state, change to 10 to test with data
    setReviews(mockData);
  }, []);

  const filteredReviews = reviews.filter(
    (r) =>
      r.company.toLowerCase().includes(searchTerm.toLowerCase()) ||
      r.reviewer.toLowerCase().includes(searchTerm.toLowerCase()) ||
      r.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="approveReviewsContainer">
      <div className="header">
        <h2>Approve Reviews</h2>
      </div>

      <div className="searchBar">
        <input
          type="text"
          className="searchInput"
          placeholder="Search Reviews..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <table className="reviewTable">
        <thead>
          <tr>
            <th>Company Name</th>
            <th>Reviewer Name</th>
            <th>Email</th>
            <th>Ratings</th>
            <th>Title</th>
            <th>Description</th>
            <th>Review Type</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredReviews.length > 0 ? (
            filteredReviews.map((review, index) => (
              <tr key={index}>
                <td>{review.company}</td>
                <td>{review.reviewer}</td>
                <td>{review.email}</td>
                <td>{review.rating} ★</td>
                <td>{review.title}</td>
                <td>{review.description}</td>
                <td>{review.type}</td>
                <td>{review.date}</td>
                <td>
                  <button className="approveBtn">Approve</button>
                  <button className="rejectBtn">Reject</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" className="noRecords">
                No matching records
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

/* Mock Reviews Generator */
function generateMockReviews(count) {
  const companies = [
    "Diakon Coir",
    "JSJ Group",
    "P Palettes",
    "SilverSutra",
    "UrbanHomes",
  ];
  const reviewers = ["Amit", "Neha", "Ravi", "Simran", "Karan"];

  return Array.from({ length: count }, (_, i) => ({
    company: companies[i % companies.length],
    reviewer: reviewers[i % reviewers.length],
    email: `user${i + 1}@mail.com`,
    rating: Math.floor(Math.random() * 5) + 1,
    title: `Great Product ${i + 1}`,
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    type: i % 2 === 0 ? "Product" : "Vendor",
    date: `2025-10-${(i % 29) + 1}`,
  }));
}

export default ApproveReviews;
